function Stages10() {
	return ( 
		<div>
			<div>
				<p>
					Regenwürmer, Tausendfüßler, Spinnen, Milben, Asseln leben in der Biomasse.
				</p>
			</div>
		</div>
	 );
}

export default Stages10;